var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { translate } from '@utils/i18n';
import { createInspectionAttachment, updateInspectionAttachment, deleteInspectionAttachment } from '../services/InspectionAttachmentsService';
import { inspectionAttachmentsKeys } from './queryKeys';
const namespace = 'features.inspections_attachments';
export function useCreateAttachment(inspectionId) {
    const queryClient = useQueryClient();
    const queryKey = inspectionAttachmentsKeys.inspection(inspectionId);
    return useMutation({
        mutationFn: (form) => createInspectionAttachment(inspectionId, form),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey });
            toast.success(translate('added_toast', { namespace }));
        },
        onError: () => {
            toast.error(translate('error_add_toast', { namespace }));
        }
    });
}
export function useUpdateAttachment(inspectionId) {
    const queryClient = useQueryClient();
    const queryKey = inspectionAttachmentsKeys.inspection(inspectionId);
    return useMutation({
        mutationFn: ({ id, form }) => updateInspectionAttachment(inspectionId, id, form),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey });
            toast.success(translate('updated_toast', { namespace }));
        },
        onError: () => {
            toast.error(translate('error_update_toast', { namespace }));
        }
    });
}
export function useDeleteAttachment(inspectionId) {
    const queryClient = useQueryClient();
    const queryKey = inspectionAttachmentsKeys.inspection(inspectionId);
    return useMutation({
        mutationFn: (attachmentId) => deleteInspectionAttachment(inspectionId, attachmentId),
        onMutate: (attachmentId) => __awaiter(this, void 0, void 0, function* () {
            yield queryClient.cancelQueries({ queryKey });
            const previous = queryClient.getQueryData(queryKey);
            queryClient.setQueryData(queryKey, (old) => old === null || old === void 0 ? void 0 : old.filter((a) => a.id !== attachmentId));
            return { previous };
        }),
        onSuccess: () => {
            toast.success(translate('deleted_toast', { namespace }));
        },
        onError: (_err, _id, context) => {
            if (context === null || context === void 0 ? void 0 : context.previous) {
                queryClient.setQueryData(queryKey, context.previous);
            }
            toast.error(translate('error_delete_toast', { namespace }));
        },
        onSettled: () => {
            void queryClient.invalidateQueries({ queryKey });
        }
    });
}
